import { set } from "lodash";
import { changeCaseOn } from "./utils";

const defaultOptions = {
  changeCaseTo: "snakeCase"
};

export const changeCaseMiddleware = (options = defaultOptions) => () => next => action => {
  if (
    action.request &&
    action.request.headers &&
    action.request.headers["Content-Type"] === "multipart/form-data"
  )
    return next(action);

  // Treat @redux-requests actions only
  if (action.request && action.request.data && !(action.meta && action.meta.noChangeCase)) {
    const newData = { ...changeCaseOn(options.changeCaseTo, action.request.data) };
    return next(set(action, "request.data", newData));
  }

  return next(action);
};
